import EventBus from '../utils/EventBus';

export const OverlayService = EventBus();
